import React, { useEffect, useState } from "react";
import NoFooterModal from "../../Common/NoFooterModal";
import { connect } from "react-redux";
import Table from "../../Common/Table";
import TableFields from "../../../constants/FeatureConfig/ActionsTableFields.json";
import { getPath } from "../../../utils";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";
import Button from "sushiweb/Button";

const RevertModal = (props) => {
  const { handleClose, activeNamespace } = props;

  console.log("revert modal props", props);

  const [dropDownModalState, setDropDownModalState] = useState(false);
  const [version, setVersion] = useState("");

  const handleRevertVersion = (key, val) => {
    if (key == "version") {
      setVersion(val);
    }
  };

  const handleSubmit = () => {
    props.syncNamespace({
      namespace: activeNamespace,
      version: version,
    });
    handleClose();
  };

  return (
    <NoFooterModal
      header={true}
      heading={`Revert ${activeNamespace}`}
      handleClose={handleClose}
      id="RevertModal"
    >
      <RevertSection>
        <p className="sectionHeading">Revert to</p>
      </RevertSection>
      <InfiniteScrollDropdown
        id={`driverServicesDropdown`}
        priorityFlag={true}
        getActiveList={() => props.getNamespaceVersions(activeNamespace)}
        nextPage={-1}
        resKey="version_info"
        modalState={dropDownModalState}
        keyName="version"
        labelKey="label"
        getDataLabelKey="version_info.version"
        keyTypeToSet="version"
        label="Namespace versions"
        handleChange={handleRevertVersion}
      />

      <Button
        data-testid="submitButton"
        className="sushi-btn"
        btnColor="coal"
        appearance="solid"
        style={{ marginTop: "10px" }}
        onClick={handleSubmit}
      >
        Revert
      </Button>
    </NoFooterModal>
  );
};

export default connect()(RevertModal);

const RevertSection = styled.div`
  .sectionHeading {
    letter-spacing: 0.18rem;
    color: ${variables.grey600};
    margin-bottom: 1.3rem;
    font-size: 5px;
  }
`;
